//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Get current user's customer information from Abas
 * @param language (optional) 
 */
export function getMyCustomerInfo(language?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.CustomerInfoDto> {
    let url_ = getBaseUrl() + "/api/customers/me?";
    if (language === null)
        throw new Error("The parameter 'language' cannot be null.");
    else if (language !== undefined)
        url_ += "language=" + encodeURIComponent("" + language) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetMyCustomerInfo,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetMyCustomerInfo?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetMyCustomerInfo(_response);
    });
}

function processGetMyCustomerInfo(response: AxiosResponse): Promise<Types.CustomerInfoDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initCustomerInfoDto(resultData200);
        return Promise.resolve<Types.CustomerInfoDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.CustomerInfoDto>(null as any);
}
let _requestConfigGetMyCustomerInfo: Partial<AxiosRequestConfig> | null;
export function getGetMyCustomerInfoRequestConfig() {
  return _requestConfigGetMyCustomerInfo;
}
export function setGetMyCustomerInfoRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetMyCustomerInfo = value;
}
export function patchGetMyCustomerInfoRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetMyCustomerInfo = patch(_requestConfigGetMyCustomerInfo ?? {});
}